import {I18n} from '@aws-amplify/core';

import {FlexiAddButton,} from '@flexinet/ui-components';
import {useActivityLog} from "../hooks/useActivityLog.ts";
import {ActivityLog} from "../types.ts";
import {useRandomActivityLogGenerator} from "../hooks/useRandomActivityLogGenerator.ts";


export const AddTestRecordButton = ({
                                        buttonText = 'Add Test Record',
                                        size = 'sm',
                                        onClick,
                                    }: {
    buttonText?: string,
    size?: string,
    onClick?: () => void
}) => {

    const {generateRandomActivityLog} = useRandomActivityLogGenerator()
    const {createRecord} = useActivityLog();

    if (typeof onClick === 'undefined') {
        onClick = () => {
            const values = generateRandomActivityLog() as ActivityLog;
            createRecord(values);
        };
    }

    return (
        <FlexiAddButton
            onClick={onClick}
            size={size}
        >
            {I18n.get(buttonText)}
        </FlexiAddButton>
    );
};
